module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-block-3-16ccba9580ee49e8298eca9e3ebceb33.jpg";